module.exports = __webpack_public_path__ + "img/bg-footer-jnj.2a3054ff.svg";